/* eslint-disable indent */
import {
    CREATE_FEED_POST,
    GET_FEEDS_RESULTS,
    CREATE_COMMENT_POST,
    DELETE_FEEDS_CATEGORY,
    DELETE_COMMENT,
    SET_POST_COMMENTS
} from "../actionTypes";  

const initialState = {
  get_feed_result: []
};

// Helper function to get feeds array from state
const getFeedsArray = (state) => {
  // Handle nested structure: state.get_feed_result might be { get_feed_result: [...] }
  if (state.get_feed_result?.get_feed_result) {
    return state.get_feed_result.get_feed_result;
  }
  if (Array.isArray(state.get_feed_result)) {
    return state.get_feed_result;
  }
  return [];
};

// Helper function to update feeds in state while preserving structure
const updateFeedsInState = (state, newFeeds) => {
  // Preserve the original structure
  if (state.get_feed_result?.get_feed_result) {
    return {
      ...state,
      get_feed_result: {
        ...state.get_feed_result,
        get_feed_result: newFeeds
      }
    };
  }
  return {
    ...state,
    get_feed_result: newFeeds
  };
};
 
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CREATE_FEED_POST: {
          const currentFeeds = getFeedsArray(state);
          const newFeeds = [payload, ...currentFeeds];
          return updateFeedsInState(state, newFeeds);
        }

        case CREATE_COMMENT_POST: {
          const currentFeeds = getFeedsArray(state);
          if (!Array.isArray(currentFeeds) || currentFeeds.length === 0) {
            return state;
          }
          
          // Use string comparison to handle type mismatches
          const feedId = String(payload.feed_id);
          
          const updatedFeeds = currentFeeds.map(post =>
            String(post.id) === feedId
              ? {
                  ...post,
                  comments: [...(post.comments || []), payload],
                  comment_count: (post.comment_count || 0) + 1,
                }
              : post
          );
          
          return updateFeedsInState(state, updatedFeeds);
        }

        case DELETE_FEEDS_CATEGORY: {
          const currentFeeds = getFeedsArray(state);
          const filteredFeeds = currentFeeds.filter(
            post => String(post.id) !== String(payload.id)
          );
          return updateFeedsInState(state, filteredFeeds);
        }

        case DELETE_COMMENT: {
          const currentFeeds = getFeedsArray(state);
          if (!Array.isArray(currentFeeds) || currentFeeds.length === 0) {
            return state;
          }
          
          // Use string comparison to handle type mismatches
          const feedId = String(payload.feed_id);
          const commentId = String(payload.comment_id);
          
          const updatedFeeds = currentFeeds.map(post =>
            String(post.id) === feedId
              ? {
                  ...post,
                  comments: (post.comments || []).filter(
                    comment => String(comment.id) !== commentId
                  ),
                  comment_count: Math.max(0, (post.comment_count || 1) - 1),
                }
              : post
          );
          
          return updateFeedsInState(state, updatedFeeds);
        }

        case GET_FEEDS_RESULTS:
          return {
            ...state,
            get_feed_result: payload
          };

        case SET_POST_COMMENTS: {
          const currentFeeds = getFeedsArray(state);
          const feedId = String(payload.feed_id);
          const updatedFeeds = currentFeeds.map(post =>
            String(post.id) === feedId
              ? { ...post, comments: payload.comments }
              : post
          );
          return updateFeedsInState(state, updatedFeeds);
        }

        case "TOGGLE_FEED_LIKE": {
          const feeds = Array.isArray(state.get_feed_result)
            ? state.get_feed_result
            : state.get_feed_result?.get_feed_result || [];
          const updatedFeeds = feeds.map(post =>
            post.id === payload.id
              ? { ...post, like_count: payload.likes, liked_by_me: payload.liked_by_me }
              : post
          );
          // Preserve the original structure
          if (Array.isArray(state.get_feed_result)) {
            return { ...state, get_feed_result: updatedFeeds };
          }
          return {
            ...state,
            get_feed_result: { ...state.get_feed_result, get_feed_result: updatedFeeds }
          };
        }

        default:
          return state;
    }
};

   